<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-title">
            <h1>Cookie policy</h1>
            <img src="https://cdn.proxyscrape.com/img/section-shape.png" alt="section-shape" />
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-12">
          <div class="itemcard legal">
            <h2>1 Cookies</h2>
            <p>
              A cookie is a small text file that is placed on the hard disk of your computer or
              mobile device when you visit a website. The cookie is placed on your device by the
              website itself ("first party cookies") or by partners of the website ("third party
              cookies"). The cookie identifies your device by a unique identification number when
              you return to the website and collects information about your browsing behaviour.
            </p>
            <p>
              There are different types of cookies. We distinguish the following cookies according
              to their purposes: there are essential or strictly necessary cookies and non-essential
              cookies (functional, analytical and targeting cookies)
            </p>
            <p>
              The <em>Belgian Act concerning the Electronic Communication</em> of 13 June 2005
              contains some provisions about cookies and the use thereof on websites. The Belgian
              implementation is deduced of the European <em>e-Privacy Directive</em>, which implies
              that the cookie usage and the cookie legislation is regulated differently in every
              European country. PROXYSCRAPE is a Belgium-based webshop and therefore follows the
              Belgian and European legislation on cookies.
            </p>
            <h2>2 Goals and utilities of cookies</h2>
            <p>
              By using the website, the visitor may agree to the use of cookies. Cookies help
              PROXYSCRAPE to optimize your visit to the website and to provide you with an optimal
              user experience. However, you are free to delete or restrict cookies at any time by
              changing your browser settings (see "Management of cookies").
            </p>
            <p>
              Disabling cookies can have an impact on the functioning of the website. Some of the
              site's features may be restricted or inaccessible. If you decide to disable cookies,
              we cannot guarantee you a smooth and optimal visit to our website. &nbsp;<br
                clear="all"
              />
            </p>
            <h2>3 Types of cookies used by PROXYSCRAPE</h2>
            <p>We distinguish the following types of cookies, according to their purposes:</p>
            <p>- <strong>Essential / Strictly necessary cookies: </strong></p>
            <p>
              These cookies are necessary for the website to function and cannot be disabled in our
              systems. They are usually only set up in response to your actions, such as setting up
              your privacy preferences, logging in or filling in forms. They are necessary for a
              good communication and they facilitate navigating (for example, returning to a
              previous page, etc.).
            </p>
            <p>- <strong>Non-essential cookies: </strong></p>
            <p>
              These cookies are not necessary for the website to function, but they do help us to
              offer an improved and personalized website.
            </p>
            <p>- <strong>Functional cookies:</strong></p>
            <p>
              These cookies enable the website to offer improved functionality and personalization.
              They can be set up by us or by external providers whose services we have added to our
              pages.
            </p>
            <p>- <strong>Analytical cookies:</strong></p>
            <p>
              With these cookies, we can track visits and traffic so that we can measure and improve
              the performance of our site. They help us to determine which pages are the most and
              the least popular and how visitors move through the site.
            </p>
            <p>- <strong>Targeting / advertising cookies:</strong></p>
            <p>
              These cookies can be set by our advertising partners via our site. They can be used by
              those companies to create a profile of your interests and show you relevant ads on
              other sites.
            </p>
            <p>
              We use two types of cookies, namely our own cookies (&lsquo;<em
                >first party cookies</em
              >&rsquo;) and cookies of carefully selected partners (&lsquo;<em
                >third party cookies</em
              >&rsquo;).
            </p>

            <p>
              Carefully read our
              <router-link to="/privacy-policy">Privacy Policy</router-link>
              for more information concerning the processing of personal data by PROXYSCRAPE.
            </p>
            <h2>4. Management of cookies</h2>
            <p>
              Make sure that cookies are enabled in your web browser. If you want to consult the
              website of PROXYSCRAPE, it is recommended you enable cookies. However, you are free to
              disable cookies in your browser settings if you wish to do so.
            </p>
            <p>
              To enable or disable cookies, you must change your browser settings (via the
              "preferences" or "options" tab). The following links will give you more information on
              how to manage your cookies. You can also consult the "help" tab of your browser.
            </p>
            <p>
              &middot;
              <a
                href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
                >How to delete and manage cookies in Internet Explorer</a
              >
            </p>
            <p>
              &middot;
              <a
                href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
                >How to delete and manage cookies in Mozilla Firefox</a
              >
            </p>
            <p>
              &middot;
              <a
                href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=en-GB"
                >How to delete and manage cookies in Chrome</a
              >
            </p>
            <p>
              &middot;
              <a
                href="https://support.apple.com/en-gb/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                >How to delete and manage cookies in Safari
              </a>
            </p>
            <br clear="all" />
            <h2>5. Rights of the visitors</h2>
            <p>
              Since cookies may constitute a processing of personal data, you as a data subject have
              the right to the lawful and secure processing of personal data. More information about
              the way in which we collect and process your personal data, as well as about your
              rights, can be found in our <a href="/privacy-policy">Privacy Policy</a>.
            </p>
            <h2>6. Contact</h2>
            <p>
              Should you still have questions or comments about cookies after reading this Cookie
              Policy, you can always contact us via
              <a href="mailto:contact@proxyscrape.com">contact@proxyscrape.com</a>.
            </p>
            <div class="juristen">
              <p>
                &copy; 2020 deJuristen IT law and Intellectual Property (<a
                  href="http://www.ictrecht.be"
                  >http://www.ictrecht.be</a
                >). The offered information is protected under copyright legislation, which means
                that&nbsp;this&nbsp;information may not be reproduced or distributed without the
                previous and written permission of deJuristen (<a
                  href="mailto:contact@dejuristen.be"
                  >contact@dejuristen.be</a
                >). deJuristen thus retains all relevant intellectual property rights.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts"></script>
